import { Badge } from "@workspace/web-ui/components/badge"
import { Tabs, TabsContent, TabsList, TabsTrigger } from "@workspace/web-ui/components/tabs"
import SubNav from "../../components/sub-nav"
import AppointmentUi from "./components/appointment-ui"
import EmptyAppointment from "./components/empty-appointment"
import { useSuspenseQuery } from "@tanstack/react-query"
import { appointmentsQueryOptions } from "./api/queries"
import { linkOptions, useNavigate, useParams } from "@tanstack/react-router"

export const appointmentsLinkOptions = (tab = 'upcoming') => linkOptions({
    to: '/dashboard/weight-loss/appointments/$tab',
    params: { tab }
})

export function AppointmentTabPage() {
    const { tab } = useParams({ strict: false })
    const navigate = useNavigate()

    const appointmentsQuery = useSuspenseQuery(appointmentsQueryOptions({ type: "upcoming" }))
    const appointmentsPastQuery = useSuspenseQuery(appointmentsQueryOptions({ type: "past" }))

    return (
        <main className="flex flex-col gap-6">
            <section className="py-10 gap-y-4">
                <SubNav
                    title="Appointments"
                    buttonOne="Go to urgent care"
                    buttonTwo="Book an appointment"
                />
                {/* Subnav Two - Accordion */}

                {/* Timeline */}
                <div className="space-y-8 ">
                    <Tabs defaultValue="upcoming" value={tab} onValueChange={(tab) => navigate(appointmentsLinkOptions(tab))}>
                        <TabsList className="h-12 w-full justify-start gap-6 rounded-none border-b mb-3 py-0">
                            <TabsTrigger
                                value="upcoming"
                                className="h-full rounded-none border-b-2 border-transparent  px-2 py-4 text-sm data-[state=active]:border-primary data-[state=active]:bg-transparent data-[state=active]:shadow-none"
                            >
                                Upcoming
                                <Badge className="ml-2 size-4 rounded-full bg-[#FFAB1F] p-2 justify-center items-center text-center text-xs">
                                    {appointmentsQuery.data?.appointments?.length || 0}
                                </Badge>
                            </TabsTrigger>
                            <TabsTrigger
                                value="past"
                                className="h-full rounded-none border-b-2 border-transparent px-0 text-sm data-[state=active]:border-primary data-[state=active]:bg-transparent data-[state=active]:shadow-none"
                            >
                                Past encounters
                                <Badge className="ml-2 size-4 rounded-full bg-[#FFAB1F] p-2 justify-center items-center text-center text-xs">
                                    {appointmentsPastQuery.data?.appointments?.length || 0}
                                </Badge>
                            </TabsTrigger>
                        </TabsList>

                        <TabsContent value="upcoming" className="flex gap-4 w-full">
                            {appointmentsQuery.data?.appointments && appointmentsQuery.data?.appointments?.length > 0 ? <AppointmentUi appointments={appointmentsQuery.data?.appointments} /> : <EmptyAppointment timeline="upcoming" />}
                        </TabsContent>

                        <TabsContent value="past" className="flex gap-4">
                            {appointmentsPastQuery.data?.appointments && appointmentsPastQuery.data?.appointments?.length > 0 ? <AppointmentUi appointments={appointmentsPastQuery.data?.appointments} /> : <EmptyAppointment timeline="past" />}
                        </TabsContent>
                    </Tabs>
                </div>
            </section>
        </main>
    )
}

